import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { mergeRegister } from '@lexical/utils'
import { BLUR_COMMAND, FOCUS_COMMAND, COMMAND_PRIORITY_LOW } from 'lexical'
import { useEffect, FC } from 'react'

interface FocusPluginProps {
  setFocus: (state: boolean) => void
}

/**
 * Custom plugin for checking is the markdown editor focused
 */
export const FocusPlugin: FC<FocusPluginProps> = ({ setFocus }) => {
  const [editor] = useLexicalComposerContext()

  useEffect(() => {
    return mergeRegister(
      editor.registerCommand(
        BLUR_COMMAND,
        () => {
          setFocus(false)
          return false
        },
        COMMAND_PRIORITY_LOW
      ),
      editor.registerCommand(
        FOCUS_COMMAND,
        () => {
          setFocus(true)
          return false
        },
        COMMAND_PRIORITY_LOW
      )
    )
  }, [editor, setFocus])

  return null
}
